import { derived, get, writable } from "svelte/store";

export const PlayerId = writable("");
export const PlayersStore = writable({});
export const PlayerOrder = writable([]);

export const CurrentStateName = writable();
export const GameStateStore = writable();

export const GameStatesStore = writable({});
export const SetupStore = writable({});
export const ItemsStore = writable({});
export const PotionsStore = writable([]);
export const SelectedActions = writable([]);
export const MonsterStore = writable({});
export const Hearts = writable({});

export const CraftStore = writable([]);
export const DecideStore = writable({});
export const SwitchMonster = writable({ unusedItems: {} });
export const PotionsDiscardPile = writable([]);
export const UsablePotions = writable([]);

export const RogueCounter = writable([]);
export const AlchemistCounter = writable([]);
export const MerchantTokenPosition = writable([]);
export const MerchantClicked = writable(false);
export const Top3Potions = writable([]);
export const ItemsToPlace = writable([]);
export const RemoveStore = writable({});

export const IsTurn = derived(
  [GameStateStore, PlayerId],
  ([gs, pid]) => gs?.active_player === pid
);

const createBattleLog = () => {
  const store = writable([]);
  const { subscribe, set, update } = store;

  let isRunning = false;
  let cache = [];

  const run = () => {
    // console.log("RUN", JSON.parse(JSON.stringify(cache)));
    if (!cache.length) {
      isRunning = false;
      return;
    }
    isRunning = true;
    store.update((s) => [...s, cache.shift()]);
    setTimeout(() => {
      run();
    }, 1100);
  };

  return {
    subscribe,
    set,
    addLog: async (log) => {
      cache.push(log);
      if (!isRunning) run();
    },
    reset: () => {
      set([]);
      isRunning = false;
      cache = [];
    },
  };
};
export const BattleLogs = createBattleLog();
export const CurrentBattleLog = derived([BattleLogs], ([bl]) => {
  // console.log("===", bl);
  return bl.length ? bl[bl.length - 1] : undefined;
});
